import { LIFESTYLE_COMMUNITIES } from "@/enums/communitiy.enum";

export const COMMUNITIES_TABS = [
  {
    label: "Water and beachfront",
    value: LIFESTYLE_COMMUNITIES.WATER_AND_BEACH_FRONT,
  },
  {
    label: "Luxury Properties",
    value: LIFESTYLE_COMMUNITIES.LUXURY_PROPERTIES,
  },
  {
    label: "Young professionals",
    value: LIFESTYLE_COMMUNITIES.YOUNG_PROFESSIONALS,
  },
  {
    label: "Family Friendly",
    value: LIFESTYLE_COMMUNITIES.FAMILY_FRIENDLY,
  },
  {
    label: "Budget friendly",
    value: LIFESTYLE_COMMUNITIES.BUDGET_FRIENDLY,
  },
];

// TODO: CONVERT THIS TO USE CDN OF SAKANIHOMES
export const COMMUNITY_PROPERTY_OPTIONS = {
  [LIFESTYLE_COMMUNITIES.WATER_AND_BEACH_FRONT]: [
    {
      key: "dubai-marina",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/dubai-marina.png/public",
      link: {
        en: "properties-for-sale-in-dubai-dubai-marina",
        ar: "عقارات-للبيع-في-دبي-دبي-مارينا",
      },
    },
    {
      key: "jbr",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/jbr.png/public",
      link: {
        en: "properties-for-sale-in-dubai-jumeirah-beach-residence",
        ar: "عقارات-للبيع-في-دبي-مساكن-شاطئ-الجميرا",
      },
    },
    {
      key: "bluewaters",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/bluewaters-island.png/public",
      link: {
        en: "properties-for-rent-in-dubai-bluewaters",
        ar: "عقارات-للايجار-في-دبي-بلوواترز",
      },
    },
    {
      key: "creek-harbour",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/dubai-creek-harbour.png/public",
      link: {
        en: "properties-for-sale-in-dubai-dubai-creek-harbour-the-lagoons",
        ar: "عقارات-للبيع-في-دبي-ميناء-خور-دبي-ذا-لاجونز",
      },
    },
  ],
  [LIFESTYLE_COMMUNITIES.LUXURY_PROPERTIES]: [
    {
      key: "emirates-hills",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/emirates-hills.png/public",
      link: {
        en: "villas-for-sale-in-dubai-emirates-hills",
        ar: "فلل-للبيع-في-دبي-تلال-الإمارات",
      },
    },
    {
      key: "al-barari",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/al-barari.png/public",
      link: {
        en: "villas-for-rent-in-dubai-al-barari",
        ar: "فلل-للايجار-في-دبي-البراري",
      },
    },
    {
      key: "arabian-ranches",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/arabian-ranches.png/public",
      link: {
        en: "properties-for-sale-in-dubai-arabian-ranches",
        ar: "عقارات-للبيع-في-دبي-المرابع-العربية",
      },
    },
    {
      key: "dubai-hills-estate",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/dubai-hills-estate.png/public",
      link: {
        en: "villas-for-sale-in-dubai-dubai-hills-estate",
        ar: "فلل-للبيع-في-دبي-دبي-هيلز-استيت",
      },
    },
  ],
  [LIFESTYLE_COMMUNITIES.YOUNG_PROFESSIONALS]: [
    {
      key: "jlt",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/jlt.png/public",
      link: {
        en: "apartments-for-rent-in-dubai-jumeirah-lake-towers",
        ar: "شقق-للايجار-في-دبي-أبراج-بحيرة-الجميرا",
      },
    },
    {
      key: "business-bay",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/business-bay.png/public",
      link: {
        en: "properties-for-rent-in-dubai-business-bay",
        ar: "عقارات-للايجار-في-دبي-الخليج-التجاري",
      },
    },
    {
      key: "dubai-silicon-oasis",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/dubai-silicon-oasis.png/public",
      link: {
        en: "properties-for-rent-in-dubai-dubai-silicon-oasis",
        ar: "عقارات-للايجار-في-دبي-واحة-السيليكون",
      },
    },
    {
      key: "city-walk",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/city-walk.png/public",
      link: {
        en: "properties-for-rent-in-dubai-city-walk",
        ar: "عقارات-للايجار-في-دبي-سيتي-ووك",
      },
    },
  ],
  [LIFESTYLE_COMMUNITIES.FAMILY_FRIENDLY]: [
    {
      key: "jumeirah",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/jumeirah.png/public",
      link: {
        en: "properties-for-rent-in-dubai-palm-jumeirah",
        ar: "عقارات-للايجار-في-دبي-نخلة-جميرا",
      },
    },
    {
      key: "umm-suqeim",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/umm-suqeim.png/public",
      link: {
        en: "villas-for-rent-in-dubai-umm-suqeim",
        ar: "فلل-للايجار-في-دبي-أم-سقيم",
      },
    },
    {
      key: "emirates-living",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/emirates-living.png/public",
      link: {
        en: "properties-for-sale-in-dubai-emirates-hills",
        ar: "عقارات-للبيع-في-دبي-تلال-الإمارات",
      },
    },
    {
      key: "arabian-ranches",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/arabian-ranches-suburbia.png/public",
      link: {
        en: "properties-for-sale-in-dubai-arabian-ranches",
        ar: "عقارات-للبيع-في-دبي-المرابع-العربية",
      },
    },
  ],
  [LIFESTYLE_COMMUNITIES.BUDGET_FRIENDLY]: [
    {
      key: "international-city",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/international-city.png/public",
      link: {
        en: "properties-for-rent-in-dubai-international-city",
        ar: "عقارات-للايجار-في-دبي-المدينة-الدولية",
      },
    },
    {
      key: "jvc",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/jvc.png/public",
      link: {
        en: "properties-for-rent-in-dubai-jumeirah-village-circle",
        ar: "عقارات-للايجار-في-دبي-قرية-الجميرا-سركل",
      },
    },
    {
      key: "discovery-gardens",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/discovery-gardens.png/public",
      link: {
        en: "properties-for-rent-in-dubai-discovery-gardens",
        ar: "عقارات-للايجار-في-دبي-ديسكفري-غاردنز",
      },
    },
    {
      key: "dubai-south",
      image:
        "https://imagedelivery.net/klgaKDuu-oCv_9lzLT_hTg/communities/dubai-south.png/public",
      link: {
        en: "properties-for-rent-in-dubai-dubai-south-dubai-world-central",
        ar: "عقارات-للايجار-في-دبي-دبي-الجنوب-مركز-دبي-العالمي",
      },
    },
  ],
};
